/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';

export const loadedDynmaic = createAction('[Dynamic] loadedDynamic');
export const loadDynmaicSuccess = createAction(
  `[Dynamic] loadDynamic`,
  props<{ prop: string; data: any | undefined }>()
);
